// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-106f140a]{color:#fff}.slider-img-class[data-v-106f140a]{max-width:100%;height:auto;display:block}.swipper-slide-prop[data-v-106f140a]{text-align:center;font-size:18px;display:flex;justify-content:center!important;align-items:center;cursor:pointer}.swipper-slide-prop[data-v-106f140a]:hover{background-color:hsla(0,0%,75%,.227)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
